export default "__VITE_ASSET__BKw0SmB$__"